module.exports = __webpack_public_path__ + "csodacsapat.jpg?48536c02ba399aa7ee61dc204b8a0514";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/csodacsapat.jpg
// module id = 76
// module chunks = 0